<template>
  <div>
    <OLink
      id="leftArrow"
      class="arrow-left hidden-left w-8 h-16 bg-black-30 flex items-center justify-end pr-4"
      :href="previousArticle"
      @click="handleClick('previous')"
    >
      <OIcon icon="chevron-left-white" class="text-white" />
    </OLink>
    <OLink
      id="rightArrow"
      class="arrow-right hidden-right w-8 h-16 bg-black-30 flex items-center justify-start pl-4"
      :href="nextArticle"
      @click="handleClick('next')"
    >
      <OIcon icon="chevron-right-white" class="text-white" />
    </OLink>
  </div>
</template>

<script>
import { defineComponent, onMounted, onBeforeUnmount, ref } from '@nuxtjs/composition-api';
import { OIcon, OLink } from '~/modules/common/components/ui';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { eventBus } from '~/modules/common/utils/eventBus';

export default defineComponent({
  components: { OIcon, OLink },
  setup() {
    const articles = ref([]);
    const nextArticle = ref('');
    const previousArticle = ref('');
    let scrollTimeout;
    let leftArrow;
    let rightArrow;
    // scroll event handler
    const handleScroll = () => {
      hideArrows();
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(showArrows, 1000);
    };

    // hide arrows
    const hideArrows = () => {
      if (!leftArrow || !rightArrow) return;
      leftArrow.classList.add('hidden-left');
      rightArrow.classList.add('hidden-right');
    };

    // show arrows
    const showArrows = () => {
      if (!leftArrow || !rightArrow) return;
      if (previousArticle.value) {
        leftArrow.classList.remove('hidden-left');
      }
      if (nextArticle.value) {
        rightArrow.classList.remove('hidden-right');
      }
    };

    // handle arrow click
    const handleClick = (direction) => {
      // TODO: analytics
    };

    if (process.client) {
      leftArrow = document.getElementById('leftArrow');
      rightArrow = document.getElementById('rightArrow');
    }

    // set arrow urls
    const setLinks = () => {
      nextArticle.value = getArticleUrl({ article: articles.value[0] }) || '';
      const referrer =
        process.client && history.length > 1 && document.referrer && document.referrer.includes('/haber/') ? document.referrer : null;
      previousArticle.value = referrer || '';
    };

    const setArticles = (list) => {
      articles.value = list;
      setLinks();
    };

    onMounted(() => {
      eventBus.on('set-navigator-articles', setArticles);
      window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
      eventBus.off('set-navigator-articles', setArticles);
      window.removeEventListener('scroll', handleScroll);
    });

    return { nextArticle, previousArticle, handleClick };
  },
});
</script>

<style scoped>
.arrow-left,
.arrow-right {
  position: fixed;
  top: 50%;
  cursor: pointer;
  transition: left 0.5s ease, right 0.5s ease;
  z-index: 20;
  margin-top: -32px;
}
.arrow-left {
  border-radius: 0 100px 100px 0;
  left: 0px;
}
.arrow-right {
  border-radius: 100px 0 0 100px;
  right: 0px;
}
.hidden-left {
  left: -32px;
}
.hidden-right {
  right: -32px;
}
</style>
